export const THEME_PREFERENCE_STORAGE_KEY = "licenciar.ui.themePreference";
export const COLOR_VISION_STORAGE_KEY = "licenciar.ui.colorVision";

export const THEME_PREFERENCES = Object.freeze(["system", "light", "dark"]);
export const COLOR_VISION_MODES = Object.freeze([
  "off",
  "protanopia",
  "deuteranopia",
  "tritanopia",
]);

export const BRAND_PRIMARY = "#2E7D32";
export const BRAND_SECONDARY = "#00796B";
export const BRAND_PRIMARY_LIGHT = "#81C784";
export const BRAND_SECONDARY_LIGHT = "#4DB6AC";

export const BACKGROUND_DEFAULT = Object.freeze({
  light: "#f5f5f5",
  dark: "#121212",
});

export const BACKGROUND_PAPER = Object.freeze({
  light: "#ffffff",
  dark: "#1e1e1e",
});

export function parseThemePreference(raw) {
  if (raw === "light" || raw === "dark" || raw === "system") {
    return raw;
  }
  return "system";
}

export function resolveMode(preference, systemDark) {
  const parsed = parseThemePreference(preference);
  if (parsed === "light") {
    return "light";
  }
  if (parsed === "dark") {
    return "dark";
  }
  return systemDark ? "dark" : "light";
}

export function parseColorVision(raw) {
  if (
    raw === "off" ||
    raw === "protanopia" ||
    raw === "deuteranopia" ||
    raw === "tritanopia"
  ) {
    return raw;
  }
  return "off";
}

export function getSystemPrefersDark() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function readStoredThemePreference() {
  try {
    return parseThemePreference(
      localStorage.getItem(THEME_PREFERENCE_STORAGE_KEY),
    );
  } catch {
    return "system";
  }
}

export function persistThemePreference(preference) {
  const parsed = parseThemePreference(preference);
  try {
    localStorage.setItem(THEME_PREFERENCE_STORAGE_KEY, parsed);
  } catch {
    return parsed;
  }
  return parsed;
}

export function readStoredColorVision() {
  try {
    return parseColorVision(localStorage.getItem(COLOR_VISION_STORAGE_KEY));
  } catch {
    return "off";
  }
}

export function persistColorVision(mode) {
  const parsed = parseColorVision(mode);
  try {
    localStorage.setItem(COLOR_VISION_STORAGE_KEY, parsed);
  } catch {
    return parsed;
  }
  return parsed;
}

export function applyDocumentColorScheme(mode) {
  if (typeof document === "undefined") {
    return;
  }

  const resolvedMode = mode === "dark" ? "dark" : "light";
  const root = document.documentElement;
  root.setAttribute("data-color-mode", resolvedMode);
  root.setAttribute("data-mui-color-scheme", resolvedMode);
  root.style.colorScheme = resolvedMode;
  root.style.backgroundColor = BACKGROUND_DEFAULT[resolvedMode];

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute("content", BACKGROUND_DEFAULT[resolvedMode]);
  }
}
